// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FOOTER_HELP_LINK = "Zeptej se n\u00e1s";
export const FORUM_POST_ADMINCLUB_MENU = "Adminclub";
export const WIKI_ARTICLE_ADD_NEW = "P\u0159idej nov\u00fd \u010dl\u00e1nek";
export const WIKI_ARTICLE_EDIT = "Uprav";
